










































import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import { PluginMixin } from '../../../mixins/plugin'

@Component
export default class ViewItem extends Mixins<PluginMixin>(PluginMixin) {
  @Prop()
  firstName: string

  @Prop()
  lastName: string

  @Prop()
  region: string

  @Prop()
  locality: string

  @Prop()
  streetAddress: string

  @Prop()
  tel: string
}
